import classes from './TestScreen.module.css';

import { Text } from '../../components/Text';
import { Card } from '../../components/Card';
import { AvatarScene } from '../../components/AvatarScene';
import { RecordingBarV2 } from '../../components/RecordingBarV2';
import TimerProgressBar from '../../components/timerProgressBar/TimerProgressBar';
import { secondsToMMSS } from '../../service/utils';
import { Stepper, StepProps, Step } from '../../components/Stepper';
import { EditDocumentIcon, HeadphonesIcon, MicIcon } from '../../components/styledIcons';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { NoteIcon } from '../../components/styledIcons/noteIcon';
const HOELTPart2 = (props: any) => {
    const {
        prepTime,
        animationMode,
        cardText,
        monologueTime,
        recordedChunks,
        hideVisualizer,
        setIsAnimationLoading,
        promptTimer,
        cubeParams,
        currentPrompt,
        currentSubTitle,
    } = props;
    const { appFontSize } = useSelector((state: RootState) => state.appConfigSlice);

    const getSteps = (isRubric?: boolean): StepProps[] => {
        return [
            {
                label: '1. Listen',
                ...(isRubric && { subLabel: 'You will hear the message twice.' }),
                icon: <HeadphonesIcon />,
            },
            {
                label: '2. Prepare',
                ...(isRubric && { subLabel: 'You will have 45 seconds to think about what to say.' }),
                icon: <EditDocumentIcon />,
            },
            {
                label: '3. Answer',
                ...(isRubric && { subLabel: 'You will have 90 seconds to speak.' }),
                icon: <MicIcon />,
            },
        ];
    };

    const getCurrentStep = (currentPrompt: any, prepTime: number) => {
        if (currentPrompt.type === 'listen') return 0; // Listen step
        if (currentPrompt.type === 'prepare') return 1; // Prepare step
        if (currentPrompt.type === 'speak' || currentPrompt.monologueQuestion) return 2; // Speak step
        return 0; // Default to Listen if nothing matches
    };
    const showStepper = currentPrompt.type !== 'rubric';
    const currentStep = getCurrentStep(currentPrompt, prepTime);

    const getStepperWidth = () => {
        // values in rem units
        switch (appFontSize) {
            case 'sm':
                return 100;
            case 'md':
                return 110;
            case 'lg':
                return 120;
        }
    };

    const renderScreenOnCondition = () => {
        if (currentPrompt.type === 'rubric') {
            return (
                <div>
                    <div
                        style={{
                            marginBottom: '3.2rem',
                        }}
                    >
                        <Text
                            text="Next, you will hear a message from a friend who needs your help to decide about something."
                            variant="heading"
                            fontWeight="semibold"
                        />
                    </div>

                    <Stepper currentActive={2} width={getStepperWidth()} orientation="vertical">
                        {getSteps(true).map((step: StepProps, index) => {
                            return <Step {...step} key={'step' + index} />;
                        })}
                    </Stepper>
                </div>
            );
        }
        if (currentPrompt.type === 'listen') {
            return (
                <div className={classes.centeredTimerBar}>
                    <TimerProgressBar
                        className={classes.audioDuration}
                        timerBarDuration={
                            !currentPrompt.audioBarPause ? currentPrompt.localizedMedia?.audioDuration : 0
                        }
                        showTime={true}
                        endTime={currentPrompt.localizedMedia?.audioDuration}
                        key={currentPrompt.audioBarPause}
                    />
                    {(currentPrompt.playAudioTwice) &&
                        <Text
                            className={classes.listenText}
                            text={!currentPrompt.audioBarPause ? currentSubTitle : ''}
                            key={currentSubTitle}
                            variant="body"
                            fontWeight='semibold'
                        />
                    }
                </div>
            );
        }
        if (currentPrompt.transcript || currentPrompt.showTimer) {
            return <Text
                text={cardText}
                className={classes.instructions}
                fontWeight='semibold'
                variant='body'
            />;
        }
        if (currentPrompt.monologueQuestion || currentPrompt.type === 'speak') {
            return (
                <div className={classes.speakScreen}>
                    <TimerProgressBar
                        timerBarDuration={monologueTime}
                        className={classes.timerProgressBar}
                        promptTimerMessage={promptTimer}
                        play={currentPrompt.monologueQuestion? true : false}
                    />
                    <RecordingBarV2
                        className={classes.sideRecordingBarV2}
                        hideVisualizer={hideVisualizer}
                        pcmChunks={recordedChunks}
                        hideText={true}
                    />
                </div>
            );
        }
    };

    return (
        <div className={classes.hoeltPageContainer}>
            <div className={classes.hoeltStepper}>
                {showStepper && (

                    <Stepper currentActive={currentStep} width={getStepperWidth()} orientation="horizontal">
                        {getSteps().map((step: StepProps, index) => {
                            return <Step {...step} key={'step' + index} />;
                        })}
                    </Stepper>
                )}
            </div>
            <div className={classes.gridHoeltContainer}>
                <div>
                    {currentPrompt.showPrepCard || prepTime ? (
                        <Card className={`${classes.hoeltTimer} ${classes.hoeltPrepCard}`}>
                            {prepTime ? (
                                <>
                                    <div className={classes.timerContent}>
                                        <Text text="Time left" variant="body" fontWeight="semibold" />
                                        <Text
                                            text={secondsToMMSS(prepTime)}
                                            variant="heading"
                                            fontWeight="bold"
                                            className={classes.prepTimeText}
                                        />
                                    </div>
                                    <div className={classes.notesContainer}>
                                        <NoteIcon id="note-id" className={classes.noteIcon} />
                                        <Text text="You may take notes" variant="body" />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <NoteIcon id="note-id" className={classes.noteIcon} />
                                    <Text text="You may take notes" variant="body" />
                                </>
                            )}
                        </Card>
                    ) : (
                        <AvatarScene
                            mode={animationMode}
                            cubeParams={cubeParams.sideCube}
                            className={classes.hoeltSideAvatar}
                            animationLoading={(loading) => setIsAnimationLoading(loading)}
                        />
                    )}
                    <RecordingBarV2
                        className={classes.sideRecordingBarV2}
                        hideVisualizer={true}
                        pcmChunks={recordedChunks}
                    />
                </div>
                <Card className={classes.hoeltInstructionsCard}>{renderScreenOnCondition()}</Card>
            </div>
        </div>
    );
};
export default HOELTPart2;
